import { Component } from "react";
import { AtomicBlockUtils } from "draft-js";

class CredentialName extends Component {
	componentDidMount() {
		const { editorState, entityType, onComplete, data } = this.props;
		const styleString = JSON.parse(window.prompt("style string"));

		if (data && styleString) {
			const content = editorState.getCurrentContent();
			const contentWithEntity = content.createEntity(entityType.type, "MUTABLE", {
				val: data,
				styleString,
			});
			const entityKey = contentWithEntity.getLastCreatedEntityKey();
			const nextState = AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, " ");

			onComplete(nextState);
		} else {
			onComplete(editorState);
		}
	}

	render() {
		return null;
	}
}
export default CredentialName;

// class CredentialName extends Component {
// 	componentDidMount() {
// 		const { editorState, entityType, onComplete, data } = this.props
// 		console.log(data)

// 		if (data && data.name) {
// 			const content = editorState.getCurrentContent()
// 			const contentWithEntity = content.createEntity(
// 				entityType.type,
// 				"MUTABLE",
// 				{
// 					val: data.name,
// 				}
// 			)
// 			const entityKey = contentWithEntity.getLastCreatedEntityKey()
// 			const nextState = RichUtils.toggleLink(
// 				editorState,
// 				editorState.getSelection(),
// 				entityKey
// 			)

// 			onComplete(nextState)
// 		} else {
// 			onComplete(editorState)
// 		}
// 	}

// 	render() {
// 		return null
// 	}
// }
// export default CredentialName
